/* CrispyCards product cards – motion, selective foil, and AJAX add-to-cart */
(() => {
  'use strict';
  if (window.__ccProductEffectsLoaded) return;
  window.__ccProductEffectsLoaded = true;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const root = document.documentElement;
  const cartUrl = () => (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
  const isVisible = (el) => !!el && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';

  function cartTarget() {
    return Array.from(document.querySelectorAll('.js-drawer-open-cart')).find(isVisible);
  }

  function setTilt(card, x, y) {
    card.style.setProperty('--cc-tilt-x', `${(-y * 5).toFixed(2)}deg`);
    card.style.setProperty('--cc-tilt-y', `${(x * 5).toFixed(2)}deg`);
    card.style.setProperty('--cc-light-x', `${((x + 1) / 2 * 100).toFixed(1)}%`);
    card.style.setProperty('--cc-light-y', `${((y + 1) / 2 * 100).toFixed(1)}%`);
  }

  document.addEventListener('pointermove', (event) => {
    if (event.pointerType === 'touch' || reducedMotion.matches) return;
    const card = event.target.closest('.cc-motion-card');
    if (!card) return;
    const image = card.querySelector('.grid-product__image-mask, .cc-product-image-wrapper');
    if (!image) return;
    const rect = image.getBoundingClientRect();
    const x = Math.max(-1, Math.min(1, ((event.clientX - rect.left) / rect.width - .5) * 2));
    const y = Math.max(-1, Math.min(1, ((event.clientY - rect.top) / rect.height - .5) * 2));
    setTilt(card, x, y);
  }, { passive: true });

  document.addEventListener('pointerout', (event) => {
    const card = event.target.closest('.cc-motion-card');
    if (card && !card.contains(event.relatedTarget)) setTilt(card, 0, 0);
  });

  function flyToCart(card) {
    const image = card.querySelector('.grid-product__image-mask img:not(.cc-fly-image), .cc-product-image');
    const target = cartTarget();
    if (!image || !target || reducedMotion.matches) return Promise.resolve();
    const a = image.getBoundingClientRect(), b = target.getBoundingClientRect();
    if (!a.width || !b.width) return Promise.resolve();
    const clone = document.createElement('img');
    clone.className = 'cc-fly-image';
    clone.src = image.currentSrc || image.src;
    clone.alt = '';
    clone.style.cssText = `position:fixed;left:${a.left}px;top:${a.top}px;width:${a.width}px;height:${a.height}px;object-fit:contain;pointer-events:none;z-index:2147483647;transform-origin:center;`;
    document.body.appendChild(clone);
    const dx = b.left + b.width / 2 - (a.left + a.width / 2);
    const dy = b.top + b.height / 2 - (a.top + a.height / 2);
    const animation = clone.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1, offset: 0 },
      { transform: `translate(${dx * .48}px,${dy * .20 - 65}px) scale(.52)`, opacity: .93, offset: .55 },
      { transform: `translate(${dx}px,${dy}px) scale(.08)`, opacity: .15, offset: 1 }
    ], { duration: 660, easing: 'cubic-bezier(.26,.7,.24,1)' });
    return animation.finished.catch(() => {}).then(() => {
      clone.remove();
      target.classList.add('cc-cart-bump');
      setTimeout(() => target.classList.remove('cc-cart-bump'), 450);
    });
  }

  function message(button, text) {
    let status = button.parentElement.querySelector('.cc-quick-add-status');
    if (!status) {
      status = document.createElement('span');
      status.className = 'cc-quick-add-status';
      status.setAttribute('role', 'status');
      button.parentElement.appendChild(status);
    }
    status.textContent = text;
  }

  // Da der unsichtbare Impulse-Link nicht mehr über dem Bild liegt,
  // öffnet ein Klick auf das Produktbild weiterhin die Produktseite.
  document.addEventListener('click', (event) => {
    if (event.target.closest('.cc-quick-add, .color-swatch, button')) return;
    const imageMask = event.target.closest('.grid-product.cc-motion-card .grid-product__image-mask');
    if (!imageMask) return;
    const card = imageMask.closest('.grid-product.cc-motion-card');
    const link = card && card.querySelector('a.grid-product__link');
    if (!link) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      window.open(link.href, '_blank', 'noopener');
    } else {
      window.location.assign(link.href);
    }
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('button[data-cc-add-to-cart]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    if (button.disabled) return;
    const card = button.closest('.cc-motion-card');
    const variantId = button.dataset.ccVariantId;
    if (!card || !/^\d+$/.test(variantId)) return;

    button.disabled = true;
    button.classList.add('cc-is-loading');
    message(button, 'Wird hinzugefügt …');
    try {
      const response = await fetch(cartUrl(), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      });
      const product = await response.json();
      if (!response.ok || product.status >= 400) throw new Error(product.description || 'Der Artikel konnte nicht hinzugefügt werden.');
      message(button, 'Zum Warenkorb hinzugefügt');
      await flyToCart(card);
      // Send the same event Impulse listens for; the existing drawer and cart logic remain in charge.
      const form = document.createElement('form');
      form.style.display = 'none';
      const input = document.createElement('input');
      input.name = 'id';
      input.value = variantId;
      form.appendChild(input);
      document.body.appendChild(form);
      form.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product, addToCartBtn: button } }));
      form.remove();
    } catch (error) {
      message(button, error.message || 'Bitte erneut versuchen.');
    } finally {
      button.disabled = false;
      button.classList.remove('cc-is-loading');
    }
  });


  // Mobile product quick view – separate from the desktop quick-add action.
  // Capture phase also prevents the Impulse full-card product link from navigating.
  let mobileSheet = null;
  let previousFocus = null;
  let quickviewOpenToken = 0;
  const isMobile = () => window.matchMedia('(max-width: 768px)').matches;
  const escapeHTML = (value) => String(value ?? '').replace(/[&<>"']/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]));
  const formatPrice = cents => new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
    style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
  }).format(Number(cents || 0) / 100);

  function finishMobileSheet(frame) {
    if (!frame || mobileSheet !== frame) return;
    ++quickviewOpenToken;
    frame.remove();
    mobileSheet = null;
    document.body.classList.remove('cc-mobile-quickview-open');
    if (previousFocus && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
  }

  function closeMobileSheet(immediate = false) {
    const frame = mobileSheet;
    if (!frame || frame.classList.contains('is-closing')) return;
    if (immediate || reducedMotion.matches) { finishMobileSheet(frame); return; }
    frame.classList.remove('is-open');
    frame.classList.add('is-closing');
    const sheet = frame.querySelector('.cc-mobile-qv__sheet');
    let settled = false;
    const finish = () => {
      if (settled) return;
      settled = true;
      finishMobileSheet(frame);
    };
    sheet.addEventListener('transitionend', event => {
      if (event.target === sheet && event.propertyName === 'transform') finish();
    });
    // Fallback for browsers that suppress transitionend.
    setTimeout(finish, 560);
  }

  async function flyQuickviewImageToCart(frame) {
    const image = frame.querySelector('.cc-mobile-qv__gallery-image');
    const target = cartTarget();
    if (!image || !target || reducedMotion.matches) return;
    const from = image.getBoundingClientRect();
    const to = target.getBoundingClientRect();
    if (!from.width || !to.width) return;
    const clone = document.createElement('img');
    clone.className = 'cc-fly-image cc-fly-image--quickview';
    clone.src = image.currentSrc || image.src;
    clone.alt = '';
    clone.style.cssText = `position:fixed;left:${from.left}px;top:${from.top}px;width:${from.width}px;height:${from.height}px;object-fit:contain;pointer-events:none;z-index:2147483647;transform-origin:center;`;
    document.body.appendChild(clone);
    const dx = to.left + to.width / 2 - (from.left + from.width / 2);
    const dy = to.top + to.height / 2 - (from.top + from.height / 2);
    try {
      await clone.animate([
        { transform: 'translate3d(0,0,0) scale(1)', opacity: 1, offset: 0 },
        { transform: `translate3d(${dx * .48}px,${dy * .38 - 66}px,0) scale(.46)`, opacity: .95, offset: .56 },
        { transform: `translate3d(${dx}px,${dy}px,0) scale(.07)`, opacity: .1, offset: 1 }
      ], { duration: 610, easing: 'cubic-bezier(.24,.72,.24,1)', fill: 'forwards' }).finished;
    } catch (_) { /* interrupted */ }
    clone.remove();
    target.classList.add('cc-cart-bump');
    setTimeout(() => target.classList.remove('cc-cart-bump'), 420);
  }

  async function openMobileSheet(card, href) {
    closeMobileSheet(true);
    const openToken = ++quickviewOpenToken;
    previousFocus = document.activeElement;
    const url = new URL(href, window.location.origin);
    const handle = card.dataset.productHandle || url.pathname.split('/products/')[1]?.split('/')[0];
    if (!handle) { window.location.assign(href); return; }
    // Load BOTH requests before animating. No late layout changes while sliding.
    const productUrl = `${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(handle)}.js`;
    const metaUrl = new URL(url.pathname, window.location.origin);
    metaUrl.searchParams.set('section_id', 'cc-quickview-metafields');
    const productRequest = fetch(productUrl, {credentials:'same-origin'})
      .then(async res => { if (!res.ok) throw new Error('Produkt konnte nicht geladen werden.'); return res.json(); });
    const metaRequest = fetch(metaUrl.toString(), {credentials:'same-origin',headers:{'Accept':'text/html'}})
      .then(res => res.ok ? res.text() : '')
      .catch(() => '');
    let product;
    try { product = await productRequest; }
    catch (error) {
      if (openToken === quickviewOpenToken) window.location.assign(href);
      return;
    }
    if (openToken !== quickviewOpenToken) return;
    const frame = document.createElement('div');
    frame.className = 'cc-mobile-qv is-preparing';
    frame.setAttribute('role','presentation');
    frame.innerHTML = `<div class="cc-mobile-qv__scrim" data-cc-qv-close></div><section class="cc-mobile-qv__sheet" role="dialog" aria-modal="true" aria-label="Produktschnellansicht"><div class="cc-mobile-qv__handle"></div><button type="button" class="cc-mobile-qv__close" aria-label="Schließen" data-cc-qv-close>×</button><div class="cc-mobile-qv__body" role="status">Produkt wird geladen …</div></section>`;
    document.body.appendChild(frame);
    mobileSheet = frame;
    document.body.classList.add('cc-mobile-quickview-open');
    // Panel remains offscreen until all content (including metafields) is ready.
    // No focus/layout changes while the panel is travelling.
    frame.addEventListener('click', e => { if (e.target.closest('[data-cc-qv-close]')) closeMobileSheet(); });
    try {
      if (mobileSheet !== frame) return;
      const variants = Array.isArray(product.variants) ? product.variants : [];
      const imageUrl = product.featured_image || card.querySelector('img')?.src || '';
      // Shopify /products/{handle}.js liefert alle Produktbilder als URL-Liste.
      const galleryImages = [...new Set((Array.isArray(product.images) ? product.images : [])
        .map(image => typeof image === 'string' ? image : image?.src)
        .filter(Boolean))];
      if (!galleryImages.length && imageUrl) galleryImages.push(imageUrl);
      const hasGallery = galleryImages.length > 1;
      const options = variants.map(v => `<option value="${v.id}" ${v.available ? '' : 'disabled'}>${escapeHTML(v.public_title && v.public_title !== 'Default Title' ? v.public_title : v.title === 'Default Title' ? 'Standard' : v.title)}${v.available ? '' : ' – Ausverkauft'}</option>`).join('');
      const body = frame.querySelector('.cc-mobile-qv__body');
      body.removeAttribute('role');
      body.innerHTML = `<div class="cc-mobile-qv__product">
        <div class="cc-mobile-qv__media" data-cc-qv-gallery aria-label="Produktbilder">
          <img class="cc-mobile-qv__gallery-image" src="${escapeHTML(galleryImages[0] || imageUrl)}" alt="${escapeHTML(product.title)} – Bild 1" loading="eager" decoding="async">
          ${hasGallery ? `<button type="button" class="cc-mobile-qv__gallery-arrow cc-mobile-qv__gallery-arrow--prev" data-cc-qv-gallery-prev aria-label="Vorheriges Produktbild"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg></button>
          <button type="button" class="cc-mobile-qv__gallery-arrow cc-mobile-qv__gallery-arrow--next" data-cc-qv-gallery-next aria-label="Nächstes Produktbild"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg></button>
          <span class="cc-mobile-qv__gallery-counter" aria-live="polite">1 / ${galleryImages.length}</span>` : ''}
        </div>
        <div class="cc-mobile-qv__info">
          <div class="cc-mobile-qv__metafields" data-cc-metafields hidden></div>
          <h2>${escapeHTML(product.title)}</h2>
          <div class="cc-mobile-qv__purchase-info"><p class="cc-mobile-qv__price"></p><p class="cc-mobile-qv__availability" aria-live="polite"></p></div>
          <div class="cc-mobile-qv__shortinfo-slot" aria-label="Deine Vorteile beim Einkauf">
            <div class="cc-mobile-qv__benefit"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 17h4V5H2v12h3"/><path d="M14 9h4l4 4v4h-3"/><circle cx="7.5" cy="17" r="2.5"/><circle cx="16.5" cy="17" r="2.5"/></svg><span><strong>Schneller Versand</strong><small>Wir bearbeiten Bestellungen zügig</small></span></div>
            <div class="cc-mobile-qv__benefit"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/><path d="m8 15 2 2 4-4"/></svg><span><strong>Sicher bezahlen</strong><small>Bequem über unseren Checkout</small></span></div>
            <div class="cc-mobile-qv__benefit"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 13v-2a8 8 0 0 1 16 0v2"/><rect x="2" y="12" width="4" height="7" rx="2"/><rect x="18" y="12" width="4" height="7" rx="2"/><path d="M20 19c0 2-2 3-5 3h-3"/></svg><span><strong>Persönlicher Support</strong><small>Fragen? Wir helfen dir gerne weiter</small></span></div>
            <div class="cc-mobile-qv__benefit"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m3 7 9-4 9 4v10l-9 4-9-4z"/><path d="m3 7 9 4 9-4M12 11v10"/><path d="m7.5 5 9 4"/></svg><span><strong>Sorgfältig verpackt</strong><small>Mit Sorgfalt für den Versand vorbereitet</small></span></div>
          </div>
        </div>
      </div>
      <div class="cc-mobile-qv__controls">
        ${variants.length > 1 ? `<label for="cc-mobile-variant">Variante wählen</label><select id="cc-mobile-variant">${options}</select>` : ''}
        <p class="cc-mobile-qv__message" role="status" aria-live="polite"></p>
        <div class="cc-mobile-qv__actions"><button type="button" class="cc-mobile-qv__add">+ In den Warenkorb</button><a class="cc-mobile-qv__details" href="${escapeHTML(href)}">Zum Produkt →</a></div>
      </div>`;
      // Galerie: Pfeiltasten, Touch-Swipe und sanfter Bildwechsel; nur bei mehreren Bildern.
      if (hasGallery) {
        const gallery = body.querySelector('[data-cc-qv-gallery]');
        const galleryImage = gallery.querySelector('.cc-mobile-qv__gallery-image');
        const counter = gallery.querySelector('.cc-mobile-qv__gallery-counter');
        let currentImage = 0;
        let gestureStart = null;
        let changeToken = 0;
        function showImage(nextIndex) {
          const next = (nextIndex + galleryImages.length) % galleryImages.length;
          if (next === currentImage) return;
          currentImage = next;
          const token = ++changeToken;
          galleryImage.classList.add('is-changing');
          const nextSrc = galleryImages[next];
          const preload = new Image();
          preload.onload = preload.onerror = () => {
            if (mobileSheet !== frame || token !== changeToken) return;
            galleryImage.src = nextSrc;
            galleryImage.alt = `${product.title} – Bild ${next + 1}`;
            counter.textContent = `${next + 1} / ${galleryImages.length}`;
            requestAnimationFrame(() => galleryImage.classList.remove('is-changing'));
          };
          preload.src = nextSrc;
        }
        gallery.querySelector('[data-cc-qv-gallery-prev]').addEventListener('click', () => showImage(currentImage - 1));
        gallery.querySelector('[data-cc-qv-gallery-next]').addEventListener('click', () => showImage(currentImage + 1));
        gallery.addEventListener('touchstart', event => {
          if (event.touches.length !== 1) return;
          gestureStart = {x:event.touches[0].clientX, y:event.touches[0].clientY};
        }, {passive:true});
        gallery.addEventListener('touchend', event => {
          if (!gestureStart || !event.changedTouches.length) return;
          const dx = event.changedTouches[0].clientX - gestureStart.x;
          const dy = event.changedTouches[0].clientY - gestureStart.y;
          gestureStart = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) showImage(currentImage + (dx < 0 ? 1 : -1));
        }, {passive:true});
      }
      // All metafields are inserted BEFORE the sheet starts moving.
      const metafieldTarget = body.querySelector('[data-cc-metafields]');
      const metaHtml = await metaRequest;
      if (mobileSheet !== frame) return;
      if (metafieldTarget && metaHtml) {
        const doc = new DOMParser().parseFromString(metaHtml, 'text/html');
        const values = Array.from(doc.querySelectorAll('[data-cc-qv-metafield]'))
          .map(el => el.textContent.trim()).filter(Boolean);
        if (values.length) {
          const row = document.createElement('div');
          row.className = 'cc-mobile-qv__meta-row';
          row.setAttribute('aria-label', 'Produktmerkmale');
          values.forEach(value => {
            const bubble = document.createElement('span');
            bubble.className = 'cc-mobile-qv__meta-value';
            bubble.textContent = value;
            row.appendChild(bubble);
          });
          metafieldTarget.replaceChildren(row);
          metafieldTarget.hidden = false;
        }
      }
      const select = body.querySelector('select');
      const add = body.querySelector('.cc-mobile-qv__add');
      const status = body.querySelector('.cc-mobile-qv__message');
      const price = body.querySelector('.cc-mobile-qv__price');
      const availability = body.querySelector('.cc-mobile-qv__availability');
      function chosen() { return variants.find(v => String(v.id) === String(select ? select.value : variants[0]?.id)); }
      function update() {
        const variant = chosen();
        price.textContent = variant ? formatPrice(variant.price) : '';
        availability.textContent = variant?.available ? 'Verfügbar' : 'Nicht verfügbar';
        availability.classList.toggle('is-unavailable', !variant?.available);
        add.disabled = !variant || !variant.available;
        add.textContent = variant?.available ? '+ In den Warenkorb' : 'Ausverkauft';
      }
      if (select) {
        const first = variants.find(v => v.available);
        if (first) select.value = String(first.id);
        select.addEventListener('change', update);
      }
      update();
      // Commit the final layout once. Animate the SHEET as one GPU layer.
      frame.classList.remove('is-preparing');
      frame.querySelector('.cc-mobile-qv__close').focus({preventScroll:true});
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if (mobileSheet === frame && !frame.classList.contains('is-closing')) frame.classList.add('is-open');
      }));
      add.addEventListener('click', async () => {
        const variant = chosen();
        if (!variant?.available || add.disabled) return;
        add.disabled = true;
        status.textContent = '';
        add.textContent = 'Wird hinzugefügt …';
        try {
          const res = await fetch(cartUrl(), {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'}, body:JSON.stringify({id:variant.id,quantity:1})});
          const item = await res.json();
          if (!res.ok || item.status >= 400) throw new Error(item.description || 'Hinzufügen fehlgeschlagen.');
          // First let the product fly to the existing cart icon, then use
          // the normal Impulse cart event. No duplicate add request.
          await flyQuickviewImageToCart(frame);
          closeMobileSheet(true);
          // Notify the existing Impulse AJAX-cart listeners; don't add the item a second time.
          const temp = document.createElement('form');
          temp.hidden = true;
          temp.innerHTML = `<input name="id" value="${variant.id}">`;
          document.body.appendChild(temp);
          temp.dispatchEvent(new CustomEvent('ajaxProduct:added', {bubbles:true,detail:{product:item,addToCartBtn:add}}));
          temp.remove();
        } catch (error) {
          status.textContent = error.message || 'Bitte erneut versuchen.';
          add.disabled = false;
          add.textContent = '+ In den Warenkorb';
        }
      });
    } catch (error) {
      const body = frame.querySelector('.cc-mobile-qv__body');
      body.innerHTML = `<p>${escapeHTML(error.message)}</p><a href="${escapeHTML(href)}">Zur Produktseite →</a>`;
      frame.classList.remove('is-preparing');
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if (mobileSheet === frame) frame.classList.add('is-open');
      }));
    }
  }

  document.addEventListener('click', e => {
    if (!isMobile() || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (e.target.closest('.cc-mobile-qv, .color-swatch, .cc-tcg-slider, .cc-quick-add, button, input, select, textarea')) return;
    const card = e.target.closest('.grid-product.cc-motion-card, .cc-product-card.cc-motion-card');
    if (!card) return;
    const a = card.querySelector('a.grid-product__link, .cc-product-image-wrapper > a');
    if (!a || (e.target.closest('a') && !card.querySelector('a.grid-product__link')?.contains(e.target) && !card.querySelector('.cc-product-image-wrapper > a')?.contains(e.target))) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    openMobileSheet(card, a.href);
  }, true);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeMobileSheet(); });
})();
